import { useTokenReadContract } from '../contracts/useTokenReadContract'

export const useTokenDecimals = () => {
  const { data, ...query } = useTokenReadContract('decimals', [])

  const decimals = data == null ? undefined : Number(data)

  return {
    decimals,
    ...query,
  }
}
